import { Controller } from "@hotwired/stimulus"

// ニックネーム設定モーダルの表示制御
export default class extends Controller {
  static targets = ["dialog", "input", "errorContainer", "errorMessage", "submitButton"]

  static values = {
    url: String,
    updatedMessage: { type: String, default: "登録しました" },
    updateFailedMessage: { type: String, default: "ニックネームの登録に失敗しました。" }
  }

  connect() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }
    this.dialogTarget.classList.add("hidden")
  }

  open() {
    if (this.dialogTarget.open) return

    this.hideError()
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.showModal()
    this.inputTarget.focus()
  }

  close() {
    if (!this.dialogTarget.open) return

    this.dialogTarget.close()
    this.dialogTarget.classList.add("hidden")
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  handleCancel(event) {
    event.preventDefault()
    this.close()
  }

  syncVisibility() {
    if (!this.dialogTarget.open) {
      this.dialogTarget.classList.add("hidden")
    }
  }

  async submit() {
    const nickname = this.inputTarget.value.trim()

    if (!nickname) {
      this.showError("ニックネームを入力してください")
      return
    }

    if (nickname.length > 8) {
      this.showError("ニックネームは8文字以内で入力してください")
      return
    }

    this.submitButtonTarget.disabled = true

    try {
      const formData = new FormData()
      formData.append("household_nickname[nickname]", nickname)

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: formData
      })

      const payload = await response.json().catch(() => ({}))

      if (response.ok) {
        this.close()
        this.dispatchFlash("notice", payload.notice || this.updatedMessageValue)
        this.refreshPage()
      } else {
        this.showError(payload.alert || this.updateFailedMessageValue)
      }
    } catch (_error) {
      this.showError(this.updateFailedMessageValue)
    } finally {
      this.submitButtonTarget.disabled = false
    }
  }

  showError(message) {
    this.errorContainerTarget.classList.remove("hidden")
    this.errorMessageTarget.textContent = message
  }

  hideError() {
    this.errorContainerTarget.classList.add("hidden")
    this.errorMessageTarget.textContent = ""
  }

  dispatchFlash(type, message) {
    // 共通flash controllerのコンテナを取得してメッセージを追加
    let container = document.getElementById("flash-messages-container")

    if (!container) {
      // flash controllerのコンテナが存在しない場合は作成する
      container = document.createElement("div")
      container.id = "flash-messages-container"
      container.setAttribute("data-controller", "flash")
      document.body.prepend(container)
    }

    // flash controllerのaddMessageメソッドを使用
    // Stimulusはcontrollerを非同期（MutationObserver経由）で接続するため、
    // コンテナを動的に作成した場合は次のmicrotaskまで待つ必要がある
    const tryAddMessage = () => {
      const flashController = this.application.getControllerForElementAndIdentifier(container, "flash")
      if (flashController) {
        flashController.addMessage(type, message)
      } else {
        requestAnimationFrame(() => {
          const ctrl = this.application.getControllerForElementAndIdentifier(container, "flash")
          if (ctrl) ctrl.addMessage(type, message)
        })
      }
    }
    tryAddMessage()
  }

  refreshPage() {
    window.location.reload()
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
